module.exports = __webpack_public_path__ + "NI.png?49391adb46980f8159ecd067f1b0fa43";